import { render, staticRenderFns } from "./ScoreAgent.vue?vue&type=template&id=655c4f54&"
import script from "./ScoreAgent.vue?vue&type=script&lang=js&"
export * from "./ScoreAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports